// import React from 'react';
// import ProjectRow from './ProjectRow';

// const ProjectTable = ({ projects, handleDelete }) => {
//   return (
//     <div className="project-card">
//       <h3>All Projects</h3>

//       <table className="project-table">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Name</th>
//             <th>Status</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//         <tbody>
//           {projects.map(p => (
//             <ProjectRow key={p.id} p={p} handleDelete={handleDelete} />
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default ProjectTable;
import React, { useState } from 'react';
import ProjectRow from './ProjectRow';
import EditProjectModal from './EditProjectModal';
import CreateProjectModal from './CreateProjectModal';

/* ─── Styles ─────────────────────────────────────────────── */
const S = {
  card: {
    background: '#fff',
    borderRadius: 14,
    boxShadow: '0 1px 3px rgba(0,0,0,.07), 0 4px 16px rgba(0,0,0,.05)',
    padding: '28px 28px',
    marginBottom: 28,
  },
  sectionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  leftRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  cardTitle: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#8892a4',
  },
  badge: {
    background: '#eef0ff',
    color: '#4361ee',
    borderRadius: 20,
    padding: '3px 10px',
    fontSize: 12,
    fontWeight: 700,
  },
  btnCreate: {
    padding: '8px 18px',
    background: 'linear-gradient(135deg, #4361ee, #3a86ff)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    boxShadow: '0 2px 8px rgba(67,97,238,.28)',
    letterSpacing: '0.02em',
    transition: 'opacity .15s',
  },
  tableWrap: {
    overflowX: 'auto',
    borderRadius: 10,
    border: '1px solid #e8ecf3',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 13.5,
  },
  th: {
    padding: '12px 16px',
    background: '#f0f3fa',
    color: '#8892a4',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    fontSize: 11,
    textAlign: 'left',
    borderBottom: '1px solid #e8ecf3',
    whiteSpace: 'nowrap',
  },
  emptyState: {
    textAlign: 'center',
    padding: '48px 20px',
    color: '#a0aec0',
  },
  emptyIcon: {
    fontSize: 40,
    marginBottom: 10,
    display: 'block',
  },
};

/* ─── ProjectTable ───────────────────────────────────────── */
const ProjectTable = ({ projects, handleDelete, handleUpdate, handleCreate }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingProject,  setEditingProject]  = useState(null);

  const handleEdit = (project) => setEditingProject(project);

  const handleModalSave = async (id, updatedData) => {
    await handleUpdate(id, updatedData);
    setEditingProject(null);
  };
  
  const handleModalCreate = async (data) => {
    await handleCreate(data);
    setShowCreateModal(false);
  };

  return (
    <>
      {/* Create Modal */}
      {showCreateModal && (
        <CreateProjectModal
          onClose={() => setShowCreateModal(false)}
          onCreate={handleModalCreate}
        />
      )}

      {/* Edit Modal */}
      {editingProject && (
        <EditProjectModal
          project={editingProject}
          onClose={() => setEditingProject(null)}
          onSave={handleModalSave}
        />
      )}

      <div style={S.card}>
        {/* Header Row */}
        <div style={S.sectionRow}>
          <div style={S.leftRow}>
            <p style={S.cardTitle}>All Projects</p>
            <span style={S.badge}>{projects.length} total</span>
          </div>

          {/* ── Create Button ── */}
          <button style={S.btnCreate} onClick={() => setShowCreateModal(true)}>
            ＋ Create Project
          </button>
        </div>

        {/* Empty State */}
        {projects.length === 0 ? (
          <div style={S.emptyState}>
            <span style={S.emptyIcon}>🗂️</span>
            <p style={{ margin: 0, fontWeight: 600, fontSize: 14 }}>No projects yet</p>
            <p style={{ margin: '4px 0 0', fontSize: 13 }}>
              Click <strong>＋ Create Project</strong> to get started.
            </p>
          </div>
        ) : (
          <div style={S.tableWrap}>
            <table style={S.table}>
              <thead>
                <tr>
                  {['Sr. No', 'Name', 'Description', 'Status', 'Start Date', 'End Date', 'Created At', 'Action'].map((h) => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {projects.map((p, i) => (              
                  <ProjectRow
                    key={p.id}
                    p={p}
                    index={i}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default ProjectTable;